define [], () ->
  ($state, RentappService, $window, GROOVE_WIDGET_PROSPECT, GROOVE_WIDGET_LANDLORD, GROOVE_WIDGET_APPLICANT) ->
    template: require("./groove.jade")
    restrict: "A"
    link: (scope, element, attrs) ->
      scope.apply_states = [
        'root.applications.apply',
        'root.applications.edit',
        'root.applications.create_account',
        'root.applications.pay',
        'root.applications.apply_success',
        'root.applications.verify.disclaimer',
        'root.applications.verify.personal_info',
        'root.applications.verify.questions',
        'root.applications.verify.verify_success',
        'root.applications.verify.verify_fail',
      ]

      scope.$watch(() ->
        $state.$current.name
      , (newVal, oldVal) ->
        if newVal in scope.apply_states
          scope.current_state = "applicant"
          $window.groove_id = GROOVE_WIDGET_APPLICANT
        else
          RentappService.getMe()
          .then (user) ->
            if user.landlord
              scope.current_state = "landlord"
              $window.groove_id = GROOVE_WIDGET_LANDLORD
            else
              scope.current_state = "applicant"
              $window.groove_id = GROOVE_WIDGET_APPLICANT
          .catch (r) ->
            scope.current_state = "prospect"
            $window.groove_id = GROOVE_WIDGET_PROSPECT
      )



// WEBPACK FOOTER //
// ./directives/groove/groove.coffee